import { styled } from "@linaria/react";
import { theme } from "@/themes/theme.ts";

export const ModalBackground = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.8);
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  background: white;
  padding: 1rem;
  border-radius: ${theme.brandBorderRadius};
  min-width: 300px;
`;

export const ModalHeader = styled.h1`
  font-size: var(--18px);
`;

export const ModalClose = styled.span`
  cursor: pointer;
  justify-self: flex-end;

  transition: all 150ms ease;
  transform-origin: 50% 20%;

  &:hover {
    scale: 1.1;
    transform: rotate(15deg);
  }
`;

export enum ClosingReason {
  Abort,
  Success,
}
